// services/whatsappService.js
import axiosInstance from '../axiosInstance';

export const getNotificationHistory = async (manifestId, passengerId = null) => {
    const url = passengerId 
        ? `/whatsapp/notification-whatsapp/${manifestId}/history-notifications?perId=${passengerId}`
        : `/whatsapp/notification-whatsapp/${manifestId}/history-notifications`;
    
    const response = await axiosInstance.get(url);
    return response.data.data || [];
};

export const retryNotifications = async (manifestId, passengerId = null) => {
    //const response = await axiosInstance.post(`/whatsapp/notification-whatsapp/${manifestId}/retry-notifications`);
    const url = passengerId 
        ? `/whatsapp/notification-whatsapp/${manifestId}/retry-notifications?perId=${passengerId}`
        : `/whatsapp/notification-whatsapp/${manifestId}/retry-notifications`;

    const response = await axiosInstance.post(url);
    return response.data.data;
};

export const updatePassengerPhone = async (perId, phone) => {
    const response = await axiosInstance.put(`/whatsapp/notification-whatsapp/${perId}/phone`, { phone });
    return response.data.data;
};